import request from '@/utils/request'

// 计划单界面
 export function apiFindPagePlanExecutionList (query) {
    return request({
      url: `/scp/scpMpsPlans/findPagePlanExecution`,
      method: 'get',
      params: query
    })
  }
 // 发放计划单
  export function apiPublishPlanSheet (query) {
    return request({
      url: `/scp/scpMpsPlans/publishPlanSheet`,
      method: 'get',
      params: query
    })
  }
   // 查询发放结果界面示例
   export function apiGrantResult (query) {
    return request({
      url: `/scp/scpMpsPlans/selectGrantResult`,
      method: 'get',
      params: query
    })
  }
